<svg xmlns="http://www.w3.org/2000/svg" width="24" height="24" fill="none" viewBox="0 0 24 24">
  <path stroke="#000" d="M1 8.5h22M.5 18V6C.5 5 1 4.5 2 4.5h20c1 0 1.5.5 1.5 1.5v12c0 1-.5 1.5-1.5 1.5H2C1 19.5.5 19 .5 18z"/>
</svg>
